import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=8a20d036&scoped=true&"
import script from "./GoBack.vue?vue&type=script&lang=ts&"
export * from "./GoBack.vue?vue&type=script&lang=ts&"
import style0 from "./GoBack.vue?vue&type=style&index=0&id=8a20d036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a20d036",
  null
  
)

export default component.exports